const COLORS = {
  white: '#FFFFFF',
  whiteLinen: '#faf4ed',
  mountainMeadowGreen: '#1BBB97',
  shamrockGreen: '#28C09E',
  wildWatermelonRed: '#FF6679',
  carnationRed: '#F8586D',
  mediumPurple: '#A96CDF',
  peranoPurle: '#ACBFF8',
  electricViolet: '#BD10E0',
  flowSidebarBackground: '#5369AD',
  flowSidebarBackgroundActive: '#35467A',
  moonRakerPurple: '#DAC0F1',
  iceColdGreen: '#AFF3E4',
  sideCarΒeige: '#f3ddbc',
  sazeracΒeige: '#FFF3E1',
  seaBuckthornOrange: '#f5a12f',
  dixieBrown: '#DE9319',
  linenBrown: '#FBF4E8',
  danger: '#f7596d',

  // Grey
  carbonGrey: '#333333',
  outerspaceGrey: '#282929',
  grey: '#808080',
  ironGrey: '#E6E6E8',
  slateGray: '#798395',
  gullGray: '#9fa9ba',
  altoGrey: '#DEDEDE',
  altoGrey2: '#CFCFCF',
  altoGrey3: '#DDDDDD',
  altoGrey4: '#D8D8D8',
  altoGrey5: '#D9D9D9',
  altoGrey6: '#DFDFDF',
  ghostGrey: '#C9CDD7',
  manateeGrey: '#989BA0',
  manateeGrey2: '#9097a8',
  silverChaliceGrey: '#A6A6A6',
  silverChaliceGrey2: '#AAAAAA',
  wildsandGrey: '#F5F5F5',
  wildSandGrey2: '#F6F6F6',
  fiordGrey: '#475369',
  boulderGrey: '#777777',
  emperorGrey: '#555555',
  doveGrey: '#727272',
  alabasterGrey: '#FBFBFB',
  alabasterGrey2: '#FAFAFA',
  alabasterGrey3: '#F9F9F9',
  ravenGrey: '#798190',
  galleryGrey: '#ECECEC',
  galleryGrey2: '#EEEEEE',
  galleryGrey3: '#f0f0f0',
  gallerySolidGrey: '#EFEFEF',
  mercuryGrey: '#E7E7E7',
  mercuryGrey2: '#E9E9E9',
  mercuryGrey3: '#E5E5E5',
  mercuryGrey4: '#e1e1e1',
  mercuryGrey5: '#e6e6e6',
  silverGrey: '#C0C0C0',
  silverGrey2: '#CACACA',
  silverGrey3: '#CCCCCC',
  athensGrey: '#E4E6EB',
  athensGrey2: '#EFEFF0',
  athensGray: '#efeff2',
  mischkaGrey: '#d4d6de',
  alabasterGrey4: '#fcfcfc',
  ghateauGrey: '#9FA3AA',
  silverChaliceGrey3: '#A1A1A1',
  solitudeGrey: '#E6F1FF',
  concreteGrey: '#F3F3F3',
  paleSkyGrey: '#676F82',
  brightGrey: '#38404F',
  silverChaliceGrey4: '#ADADAD',

  // Blue
  rhinoBlue: '#2f3c64',
  ebonyClayBlue: '#2c3444',
  cloudBurstBlue: '#253258',
  sanjuanBlue: '#35467A',
  ribbonBlue: '#0170FF',
  cornflowerBlue: '#647CC4',
  havelockBlue: '#4A90E2',
  curiousBlue: '#1995DB',
  malibuBlue: '#5AA1FE',
  sanMarinoBlue: '#5369AD',
  malibuBlue2: '#86A9FF',
  moodyBlue: '#7188CE',
  moodyBlue2: '#7087CC',
  moodyBlue3: '#7087cb',
  jordyBlue: '#9CBEF8',
  jordyBlue2: '#95B6EF',
  eastBayBlue: '#46547E',
  eastBayBlue2: '#465580',
  solitudeBlue2: '#E4F0FF',
  periwinkleBlue: '#D3DEFF',
  zumthorBlue: '#ECF4FF',
  chetwodeBlue: '#869ad5',
  chetwodeBlue2: '#7B93DA',
  chetwodeBlue3: '#8699D4',
  moonRakerBlue: '#c4d0f3',
  hawkesBlue: '#e4ebfe',
  fogBlue: '#dae1ff',
  dullLavenderBlue: '#a1b2e7',
  kashmirBlue: '#516195',
  oxfordBlue: '#2F3849',
  dodgerBlue: '#4396F7',
  ceruleanBlue: '#018DD9',
  whiteiceBlue: '#E5F3FB',
  botticelliBlue: '#D5E5EE',

  // Green
  alohaGreen: '#1EBB97',
  aquaspringGreen: '#E8F8F4',

  // Purple
  richPurple: '#c26ed3',
  lavenderPurple: '#C36AD5',
  lilacPurple: '#F9F0FA',
};

export default COLORS;
